// ...existing code...
import {
  DateOrNullOrUndefined,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';

export type BaseChartCommentV2 = {
  id: number;
  comment_date: string | Date;
  comment: string;
  created_at: string | Date;
  updated_at: string | Date;
  deleted_at?: string | Date;
};


export type ChartCommentV2 = BaseChartCommentV2 & {
   plan_id: number | null;
   bip_id: number | null; 
};


export function buildChartCommentV2(data: Partial<ChartCommentV2> | undefined): ChartCommentV2 | null {
  if (!data) return null;

  const id = NumberOrNullOrUndefined((data).id) as number;
  const rawPlan = NumberOrNullOrUndefined((data).plan_id);
  const rawBip = NumberOrNullOrUndefined((data).bip_id);

  const plan_id = rawPlan ?? null;
  const bip_id = rawBip ?? null;

  const hasPlan = plan_id !== null;
  const hasBip = bip_id !== null;

  if ((hasPlan && hasBip) || (!hasPlan && !hasBip)) {
    console.warn('buildChartCommentV2: invalid data, must have exactly one of plan_id or bip_id', data);
    return null;
  }

  const result: ChartCommentV2 = {
    id,
    plan_id: hasPlan ? (plan_id as number) : null,
    bip_id: hasBip ? (bip_id as number) : null,
    comment_date: DateOrNullOrUndefined((data).comment_date) ?? '',
    comment: StringOrNullOrUndefined((data).comment) ?? '',
    created_at: DateOrNullOrUndefined((data).created_at) ?? '',
    updated_at: DateOrNullOrUndefined((data).updated_at) ?? '',
    deleted_at: DateOrNullOrUndefined((data).deleted_at),
  };

  return result;
}
